import BaseRepository from "~/repositories/BaseRepository";
import SampleTemplateModel from "~/models/SampleTemplateModel";

type IndexParams = {
  content: string
}

class SampleTemplatesRepository extends BaseRepository {
  async index(params: IndexParams): Promise<any> { // eslint-disable-line @typescript-eslint/no-explicit-any
    const url = "/api/v1/sample_templates";
    const results = await this._get(url, params );
    return new SampleTemplateModel(results.data);
  }
}
export default SampleTemplatesRepository;
